import { THookSelectorFetchDataInfo, TSelector, useGenFetchDataSelector } from 'redux/rootSelectors';
import { offerState } from './reducer';
import { TOfferItem } from './types';

export const selectorOfferInfo: TSelector<offerState['offerInfo']> = ({
  offerReducer,
}) => offerReducer.offerInfo;

export const useOfferInfo: THookSelectorFetchDataInfo<TOfferItem> = () =>
  useGenFetchDataSelector(selectorOfferInfo);